const getModuleState = (state) => state.admin;

export const getPageImages = (state) => getModuleState(state).pageImages;
export const getPageTitles = (state) => getModuleState(state).pageTitles;
export const getPageDescriptions = (state) => getModuleState(state).pageDescriptions;